'use client';

import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as React from 'react';

import { cn } from '#lib/utils';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List> & {
    tablistRef?: React.Ref<HTMLUListElement>;
  }
>(({ className, children, tablistRef, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn('tds-tabs__list-container', className)}
    {...props}
    asChild
  >
    <ul
      ref={tablistRef}
      role="tablist"
      className="tds-tabs__list tds-tabs__list--scrollable"
    >
      {children}
    </ul>
  </TabsPrimitive.List>
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <li role="presentation">
    <TabsPrimitive.Trigger
      role="tab"
      ref={ref}
      className={cn('tds-tabs__tab-button', className)}
      {...props}
    />
  </li>
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    role="tabpanel"
    className={cn('tds-body-content !pt-3', className)}
    {...props}
  >
    {children}
  </TabsPrimitive.Content>
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsContent, TabsList, TabsTrigger };
